import { DecryptJson, EncryptJson } from "./encryDecry";

function getUser() {
  let name = "user=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export const setAuth = (data) => {
  document.cookie = `user=${EncryptJson(data)}; path=/`;
};

export const getAuth = () => {
  const user = getUser();
  return user ? DecryptJson(user) : null;
};

export const removeAuth = () => {
  document.cookie = "user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
};

export const isAdmin = (roleId) => roleId == 1;

export const isApprover = (roleId) => roleId == 2;

export const isStaff = (roleId) => roleId == 3;

export const isPublisher = (roleId) => isAdmin(roleId) || isApprover(roleId);
